<template>
    <hc-form ref="childForm" label-position="left" :label-width="labelWitdh" :model="formData">
        <!-- 文本类的配置 -->
        <template v-if="currentType === STRING">
            <!-- <hc-form-item label="文本类型" prop="textType">
                <hc-radio-group v-model="formData.textType">
                    <hc-radio label="short">
                        短文本
                    </hc-radio>
                    <hc-radio label="long">
                        长文本
                    </hc-radio>
                </hc-radio-group>
            </hc-form-item> -->
            <hc-form-item
                label="文本长度"
                prop="textLengthRange"
                :rules="rules.textLengthRange"
            >
                <length-range v-model="formData.textLengthRange" />
            </hc-form-item>
        </template>
        <!-- 数值类的配置 -->
        <template v-else-if="currentType === NUMBER">
            <!-- <hc-form-item label="整数长度" prop="integerLength">
                <hc-input-number v-model="formData.integerLength" :min="0" :max="15" controls-position="right" />
            </hc-form-item> -->
            <hc-form-item label="小数位数" prop="decimalDigit">
                <hc-input v-model="formData.decimalDigit" :disabled="decimalDigitDisabled" type="number" :precision="0" :min="0" placeholder="请输入大于等于 0 的整数" />
            </hc-form-item>
            <hc-form-item label="最小值" prop="minNum">
                <hc-input v-model="formData.minNum" type="number" placeholder="请输入最小值" />
            </hc-form-item>
            <hc-form-item label="最大值" prop="maxNum" :rules="rules.maxMinNum">
                <hc-input v-model="formData.maxNum" type="number" placeholder="请输入最大值" />
            </hc-form-item>
        </template>
        <!-- 枚举类的配置 -->
        <template v-else-if="currentType === ENUMERATION">
            <hc-form-item label="是否多选" prop="multiOption">
                <hc-radio-group v-model="formData.multiOption" :disabled="multiOptionDisabled">
                    <hc-radio :label="true">
                        是
                    </hc-radio>
                    <hc-radio :label="false">
                        否
                    </hc-radio>
                </hc-radio-group>
            </hc-form-item>
            <hc-form-item v-if="formData.multiOption" label="选项值类型" prop="type">
                <hc-select v-model="enumValue" placeholder="请选择选项值类型">
                    <hc-option
                        v-for="item in enumOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                    />
                </hc-select>
            </hc-form-item>
            <!-- <hc-form-item label="添加方式" prop="optionType">
                <hc-radio-group v-model="formData.optionType">
                    <hc-radio label="general" disabled>
                        通用选项集
                    </hc-radio>
                    <hc-radio label="customize">
                        自定义选项集
                    </hc-radio>
                </hc-radio-group>
            </hc-form-item>
            <hc-form-item label="选项信息" prop="defaultChecked">
                <component
                    :is="formData.multiOption ? 'hc-checkbox-group' : 'hc-radio-group'"
                    v-model="formData.defaultChecked"
                    class="group-box"
                >
                    <draggable v-model="formData.options" handle=".handle">
                        <div
                            v-for="(item, index) in formData.options"
                            :key="index"
                            class="option-info"
                        >
                            <svg-icon name="resource-object.drag" class="drag-prefix handle" />
                            <component :is="formData.multiOption ? 'hc-checkbox' : 'hc-radio'" :label="item.id" />
                            <hc-input v-model="item.label" placeholder="请输入显示文本" />
                            <hc-input v-model="item.value" placeholder="请输入选项值" />
                            <svg-icon
                                class="delete"
                                name="resource-object.delete"
                                @click="deleteEnumOption(index)"
                            />
                        </div>
                    </draggable>
                </component>
                <hc-button icon="hc-icon-plus" @click="addEnumOption">
                    添加选项
                </hc-button>
            </hc-form-item> -->
        </template>
        <!-- 布尔值类的配置 暂无配置，留位 -->
        <template v-else-if="currentType === BOOLEAN" />
        <!-- 日期时间类的配置 -->
        <template v-else-if="currentType === DATE_TIME">
            <hc-form-item label="格式" prop="dateTimeFormat">
                <hc-select v-model="formData.dateTimeFormat">
                    <hc-option value="yyyy-MM-dd HH:mm:ss" label="年月日+时分秒" />
                    <hc-option value="yyyy-MM-dd" label="年月日" />
                    <hc-option value="HH:mm:ss" label="时分秒" />
                </hc-select>
                <span class="form-tips text">
                    示例：{{ dateTimeTips }}
                </span>
            </hc-form-item>
        </template>
        <!-- 图片类的配置 -->
        <template v-else-if="currentType === IMAGE">
            <hc-form-item label="单张图片" prop="singleImage">
                <hc-switch :value="formData.singleImage" :disabled="singleImageDisabled" @change="handleChangeSingleImage" />
            </hc-form-item>
            <hc-form-item v-if="!formData.singleImage" label="最大上传数" prop="maxNum">
                <hc-input-number v-model="formData.maxNum" controls-position="right" :precision="0" :min="1" />
            </hc-form-item>
        </template>
        <!-- 附件类的配置 -->
        <template v-else-if="currentType === FILE">
            <hc-form-item
                label="最大上传数"
                prop="maxNum"
                :rules="[
                    { required: true, message: '请选择最大上传数', trigger: ['change'] },
                ]"
            >
                <hc-input-number
                    v-model="formData.maxNum"
                    controls-position="right"
                    :precision="0"
                    :min="1"
                    :max="20"
                    @change="formatMaxNum"
                />
            </hc-form-item>
            <hc-form-item
                label="文件大小"
                prop="maxSize"
            >
                <hc-input-number
                    v-model="formData.maxSize"
                    controls-position="right"
                    :controls="false"
                    :precision="0"
                    :min="1"
                    :max="30"
                    suffix="M / 个"
                />
            </hc-form-item>
        </template>
        <!-- 对象类的配置 -->
        <template v-else-if="currentType === OBJECT" />
        <!-- 对象数组类的配置 -->
        <template v-else-if="currentType === OBJECT_ARRAY" />
        <!-- 是否必填 -->
        <hc-form-item v-if="currentType !== BOOLEAN" label="是否必填" prop="required">
            <hc-radio-group v-model="formData.required">
                <hc-radio :label="true">
                    是
                </hc-radio>
                <hc-radio :label="false">
                    否
                </hc-radio>
            </hc-radio-group>
        </hc-form-item>
        <!-- 字段类型对应的组件 -->
        <hc-form-item
            v-if="currentTypeComponents.length"
            label="输入组件"
            prop="defaultComponent"
            :rules="[
                { required: true, message: '请选择输入组件', trigger: ['blur'] },
            ]"
        >
            <hc-select v-model="formData.defaultComponent">
                <hc-option
                    v-for="component in currentTypeComponents"
                    :key="component.name"
                    :value="component.name"
                    :label="component.title"
                />
            </hc-select>
        </hc-form-item>
    </hc-form>
</template>

<script>
import _ from 'lodash'
import LengthRange from '@common/components/length-range'
import {
    STRING,
    IMAGE,
    FILE,
    OBJECT,
    NUMBER,
    BOOLEAN,
    DATE_TIME,
    ENUMERATION,
    OBJECT_ARRAY,
    ObjectFieldType,
    DefaultTypeValue,
    ComponentsMap,
    TypeRelatedComponents,
} from './const'

export default {
    name: 'ObjectDetailTypeForm',
    components: {
        LengthRange,
    },
    props: {
        // config，当前 type 中的配置内容
        value: {
            type: Object,
            default: () => ({
                type: 'string',
            }),
        },
        // 真实的字段类型
        fieldType: {
            type: String,
            default: 'string',
        },
        optType: {
            type: String,
        },
        labelWitdh: {
            type: String,
            default: '100px',
        },
        filterRules: {
            type: Object,
            default: () => {},
        },
        ignoreDefault: Boolean,
    },
    data() {
        const validateTextLengthRange = (rule, value, callback) => {
            if (value[1] > 65535 || value[1] < 1) {
                callback(
                    new Error('请输入 1 - 65535 范围中的数字')
                )
                return
            }
            callback()
        }
        const { fieldType } =  this
        const enumOptions = [
            { label: '文本', value: 'stringArray' },
            { label: '数值', value: 'numberArray' },
        ]

        return {
            STRING,
            FILE,
            IMAGE,
            OBJECT,
            NUMBER,
            BOOLEAN,
            DATE_TIME,
            ENUMERATION,
            OBJECT_ARRAY,
            ComponentsMap,
            TypeRelatedComponents,
            // 默认值初始化，不是规定的则初始默认 stringArray
            enumValue: ['stringArray', 'numberArray'].includes(fieldType) ? fieldType : 'stringArray',
            enumOptions,
            rules: {
                textLengthRange: [
                    { required: true, message: '请输入文本长度范围', trigger: ['blur'] },
                    { validator: validateTextLengthRange, trigger: 'blur' },
                ],
                maxMinNum: [
                    { validator: this.maxMinNum, trigger: 'blur' },
                ],
            },
            
        }
    },
    computed: {
        // 真实字段类型的抽象分类
        currentType() {
            return (ObjectFieldType.find(type => type.name === this.fieldType) || {}).type
        },
        // 当前表单配置项
        formData: {
            get() {
                return this.value
            },
            set(data) {
                this.$emit('input', data)
            },
        },
        // 当前字段类型对应的可选组件
        currentTypeComponents() {
            const data = (this.TypeRelatedComponents[this.currentType] || []).reduce((all, type) => {
                const { name, conditionName, conditionVal } = type
                if (conditionName && this.formData[conditionName] !== conditionVal) return all
                return [...all, { ...type, name, title: this.ComponentsMap[name] }]
            }, [])
            const { componentsType } = this.filterRules || {}
            return componentsType && Array.isArray(componentsType) ? data.filter(i => componentsType.includes(i.name)) : data
        },
        dateTimeTips() {
            const tipsMap = new Map([['yyyy-MM-dd HH:mm:ss', '2022-06-24 17:50:00'], ['yyyy-MM-dd', '2022-06-24'], ['HH:mm:ss', '14:00:00']])

            return tipsMap.get(this.formData.dateTimeFormat)
        },
        multiOptionDisabled() {
            const { multiOptionDisabled } = this.filterRules || {}
            return multiOptionDisabled
        },
        singleImageDisabled() {
            const { singleImageDisabled } = this.filterRules || {}
            return singleImageDisabled
        },
        decimalDigitDisabled() {
            const { decimalDigitDisabled } = this.filterRules || {}
            return decimalDigitDisabled
        },
    },
    watch: {
        fieldType: {
            immediate: true,
            // 类型变动重置数据
            handler(type) {
                const result = DefaultTypeValue[type]
                if (result && (this.value.type !== type || this.optType === '添加')) {
                    this.formData = {
                        ...result,
                    }
                }
            },
        },
        // 多选变动切换默认 type
        'formData.multiOption'(isMulti) {
            if (this.currentType !== ENUMERATION) return
            // this.formData.defaultChecked = isMulti ? [] : ''
            this.formData.type = isMulti ? 'stringArray' : 'enumeration'
        },
        'enumValue'(type) {
            this.formData.type = type
        },
        // 选项变动时修改默认选中值
        // 'formData.options'(options) {
        //     if (options) {
        //         const { defaultChecked } = this.formData
        //         if (this.formData.multiOption) {
        //             this.formData.defaultChecked = defaultChecked.filter(item => options.findIndex(option => option.id === item) >= 0)
        //         } else {
        //             this.formData.defaultChecked = options.findIndex(option => option.id === defaultChecked) >= 0 ?  defaultChecked : ''
        //         }
        //     }
        // },
        'formData.decimalDigit'(v) {
            if (v && v < 0) {
                this.formData.decimalDigit = null
            }
        },
        currentTypeComponents(val) {
            const include = val.find(i => i.name === this.formData.defaultComponent)
            if (!include) {
                this.formData.defaultComponent = (val[0] || {}).name
            }
        },
        'formData.dateTimeFormat'(type) {
            const typeMap = new Map([['yyyy-MM-dd HH:mm:ss', 'dateTime'], ['yyyy-MM-dd', 'date'], ['HH:mm:ss', 'time']])

            if (type) {
                this.formData.type = typeMap.get(type)
            }
        },
        // 类型变动切换默认选中的组件
        'formData.textType': {
            immediate: false,
            handler(type) {
                const component = type === 'long' ? this.currentTypeComponents[1] : this.currentTypeComponents[0] || {}
                this.formData.defaultComponent = component.name
            },
        },
        filterRules: {
            deep: true,
            immediate: true,
            handler(ruels) {
                if (ruels) {
                    const {
                        multiOption,
                        singleImage,
                        onlyNumber,
                        onlyString,
                    } = ruels
                    if (_.isBoolean(multiOption)) {
                        this.formData.multiOption = multiOption
                        this.$set(this.formData, 'multiOption', multiOption)
                    }
                    if (_.isBoolean(singleImage)) {
                        this.formData.singleImage = singleImage
                        if (singleImage) {
                            this.formData.maxNum = 1
                        }
                    }
                    if (_.isBoolean(onlyNumber) && onlyNumber) {
                        this.enumOptions[0].disabled = true
                        if (this.enumValue === 'stringArray') {
                            this.$nextTick(() => {
                                this.enumValue = 'numberArray'
                            })
                        }
                    }
                    if (_.isBoolean(onlyString) && onlyString) {
                        this.enumOptions[1].disabled = true
                        if (this.enumValue === 'numberArray') {
                            this.$nextTick(() => {
                                this.enumValue = 'stringArray'
                            })
                        }
                    }
                }
            },
        },
    },
    methods: {
        addEnumOption() {
            this.formData.options.push({ id: window.crypto.randomUUID(), label: '', value: '' })
        },
        deleteEnumOption(index) {
            this.formData.options.splice(index, 1)
        },
        validateChildForm(cb) {
            return this.$refs.childForm.validate(cb)
        },
        clearValidate() {
            return this.$refs.childForm.clearValidate()
        },
        maxMinNum(rule, value, callback) {
            const minVal = this.formData.minNum
            if (value && minVal && Number(value) < Number(minVal)) {
                callback(
                    new Error('请输入比最小值大的值')
                )
                return
            }
            callback()
        },
        handleChangeSingleImage(v) {
            this.$set(this.formData, 'singleImage', v)
            if (v) {
                this.formData.maxNum = 1
            } else {
                this.formData.maxNum = DefaultTypeValue[IMAGE].maxNum
            }
        },
        formatMaxNum(val) {
            setTimeout(() => {
                const maxNum = !val ? 10 : val
                this.formData.maxNum = maxNum
            }, 0)
        },
    },
}
</script>
<style lang="less" scoped>
.hc-input-number {
    width: 100%;
}
.option-info {
    width: 100%;
    display: flex;
    padding: 4px 8px;
    border-radius: 3px;
    align-items: center;
    background: #F2F3F5;
    &:not(:last-child) {
        margin-bottom: 8px;
    }
    .svg-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }
    &:hover {
        .drag-prefix {
            color: #666;
        }
    }
    .drag-prefix {
        cursor: move;
        color: #999;
        margin-right: 8px;
    }
    .delete {
        margin-left: 8px;
        cursor: pointer;
    }
    .hc-input {
        margin-left: 8px;
    }
    .hc-radio {
        margin: 0;
        /deep/ .hc-radio__label {
            padding: 0;
        }
    }
    .hc-input,
    .hc-radio,
    .hc-checkbox {
        line-height: 32px;
        /deep/ &__label {
            display: none;
        }
    }
}
.group-box {
    display: block;
}
.hc-button {
    width: 100%;
}
.hc-radio-group,
.hc-checkbox-group {
    width: 100%;
}
/deep/ .hc-input__inner {
    line-height: 1 !important;
}
</style>
